// extracted by mini-css-extract-plugin
var _1 = "TrialLogo_centered__51ba1";
var _2 = "TrialLogo_description__f79eb";
var _3 = "TrialLogo_footer__7f225";
var _4 = "TrialLogo_link__d0ffc";
var _5 = "TrialLogo_logo__7884c";
var _6 = "TrialLogo_mobile__0bca3";
var _7 = "TrialLogo_root__35af5";
var _8 = "TrialLogo_tablet__eb1ae";
var _9 = "TrialLogo_title__6d3ba";
export { _1 as "centered", _2 as "description", _3 as "footer", _4 as "link", _5 as "logo", _6 as "mobile", _7 as "root", _8 as "tablet", _9 as "title" }
